import { getAkCloneStatus } from '../../services';
import useOverviewCheck from './useOverviewCheck';
import OverviewCardShell from './OverviewCardShell';

export default function AkCloneCard() {
  const { data, isLoading, error } = useOverviewCheck(getAkCloneStatus);

  return (
    <OverviewCardShell title="AK Clone" isLoading={isLoading} error={error} good={data?.good}>
      {data && (
        <div className="space-y-1 text-sm text-slate-700">
          {data.sites.map((site) => (
            <p key={site.name}>
              {site.good ? '' : '⚠️ '}
              <span className="font-medium">{site.name}</span>:{' '}
              {site.money === null ? (
                <span className="text-red-600">Không lấy được dữ liệu</span>
              ) : (
                <span className={site.good ? '' : 'font-bold text-amber-600'}>
                  {(site.money / 1000).toFixed(0)}k
                </span>
              )}
            </p>
          ))}
          <p className="text-xs text-slate-400">Ngưỡng: {(data.money_threshold / 1000).toFixed(0)}k</p>
        </div>
      )}
    </OverviewCardShell>
  );
}
